export default __webpack_public_path__ + "static/media/img5.c6e100a8.PNG";